// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { NavigationUtil } from 'utils/NavigationUtil';
import { StringUtil } from 'utils/StringUtil';
import { HTMLView } from 'components/atoms/htmlView';
import { useViewport } from 'components/templates/viewportProvider';
import type { Vertical } from 'types/common';
import { Image } from 'components/atoms/image';
// eslint-disable-next-line
import styles from "./styles.scss";
import { RouteUtil } from 'utils/RouteUtil';

type Props = {
  data: Vertical,
  history: Object,
  onPress: () => void,
};

const MenuCard = (props: Props) => {
  const { isMobile } = useViewport();
  const { data, onPress } = props;

  // TODO: Clean-up
  const handleClick = pathName => {
    if (pathName.includes('Portfolio in India')) {
      window.location.href = 'https://www.total-environment.com/homes'; 
      return;
    }
    let name = StringUtil.sliceHtml(pathName);
    const routeName = NavigationUtil.getRouteForVertical(name);
    const pathname = props.history.location.pathname;
    // checks whether the current path and clicked verticals are same ,
    // if then passes a prop to MainMenu to close the MainMenu overlay.
    if (pathname === routeName) onPress();
    RouteUtil.setRouteChange(props, data.route);
  };

  const imageUrl = isMobile ? data.mobileImageUrl : data.imageUrl;
  const thumbnailUrl = isMobile ? data.thumbnailMobileUrl : data.thumbnailUrl;
  return (
    <div
      className="vertical-list"
      onClick={() => handleClick(data.name, data.id)}
    >
      <div className="vertical-image">
        <Image
          className={'image'}
          thumbNail={thumbnailUrl}
          src={imageUrl}
          alt={'vertical'}
          isHoveredImagePresent={true}
        />
      </div>
      <div className="vertical-text">
        <HTMLView
          html={data.name}
          tagName={'div'}
          className={'vertical-list-title'}
        />
        <HTMLView
          html={data.description}
          tagName={'p'}
          className={'vertical-list-description'}
        />
        <a
          onClick={() => handleClick(data.name, data.id)}
          className={'vertical-list-button'}
        >
          LEARN MORE
        </a>
      </div>
    </div>
  );
};

export default withRouter(MenuCard);
